const __WEBPACK_NAMESPACE_OBJECT__ = i18nextBrowserLanguageDetector;